module.exports = __webpack_public_path__ + "img/logo.3379f12.svg";